import React, { useEffect, useState } from "react";
import { Link, Outlet, NavLink, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LogOut, Fuel, Building2, GraduationCap, Camera, FileText, Info, LayoutDashboard, Users, ClipboardList, MapPinned } from "lucide-react";
import Logo from "../components/Logo";

const SECTIONS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/airport-info", label: "Airport Info", icon: Info },
  { to: "/admin/fuel", label: "Fuel Prices", icon: Fuel },
  { to: "/admin/fees", label: "Layout & Fees", icon: ClipboardList },
  { to: "/admin/hangars", label: "Hangars", icon: Building2 },
  { to: "/admin/flight-schools", label: "Flight Schools", icon: GraduationCap },
  { to: "/admin/leadership", label: "Board & Staff", icon: Users },
  { to: "/admin/attractions", label: "Local Attractions", icon: MapPinned },
  { to: "/admin/photos", label: "Photos", icon: Camera },
  { to: "/admin/reports", label: "Reports", icon: FileText },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();
  const navigate = useNavigate();

  if (!ready) return <div className="p-12">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div data-testid="admin-layout" className="min-h-screen bg-slate-50 grid grid-cols-12">
      <aside className="col-span-12 md:col-span-3 lg:col-span-2 bg-slate-950 text-white p-6 md:min-h-screen">
        <Link to="/" className="flex items-center gap-3 text-white font-display font-bold">
          <Logo size="md" variant="dark" />
          <span className="text-sm">KSME Admin</span>
        </Link>
        <nav className="mt-8 space-y-1">
          {SECTIONS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`admin-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 text-sm border-l-2 ${
                  isActive ? "border-sky-400 bg-white/5 text-white" : "border-transparent text-slate-300 hover:bg-white/5"
                }`
              }
            >
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-10 pt-6 border-t border-white/10 text-xs text-slate-400">
          Signed in as
          <div className="text-white font-medium mt-1">{user.email}</div>
        </div>
        <button
          data-testid="admin-logout"
          onClick={async () => { await logout(); navigate("/admin/login"); }}
          className="mt-4 inline-flex items-center gap-2 text-xs uppercase tracking-widest border border-white/20 px-3 py-2 hover:bg-white/10"
        >
          <LogOut className="h-4 w-4" /> Logout
        </button>
      </aside>

      <main className="col-span-12 md:col-span-9 lg:col-span-10 p-6 md:p-10">
        <Outlet />
      </main>
    </div>
  );
}
